// Browser → intake-functions API (separate from the Ops Hub /api). Every call returns
// { ok, status, data } and never throws; a network error is status 0, a missing token is 401
// with no request made. Tokens and response bodies are never logged or stored.
import { getApiToken } from "../auth/apiToken.js";
import { INTAKE_API_URL } from "./config.js";

async function call(method, path, body, { blob = false } = {}) {
  if (!INTAKE_API_URL) return { ok: false, status: 0, data: null };
  try {
    const token = await getApiToken();
    if (!token) return { ok: false, status: 401, data: null };
    const headers = { Authorization: `Bearer ${token}` };
    if (body !== undefined) headers["Content-Type"] = "application/json";
    const res = await fetch(`${INTAKE_API_URL}${path}`, { method, headers, body: body === undefined ? undefined : JSON.stringify(body) });
    let data = null;
    try { data = blob && res.ok ? await res.blob() : await res.json(); } catch (_) { data = null; }
    return { ok: res.ok, status: res.status, data };
  } catch (_) {
    return { ok: false, status: 0, data: null };
  }
}

const e = encodeURIComponent;

export const intakeApi = {
  createInvite: ({ clientId, clientDisplayName, contactEmail, notifyEmails }) =>
    call("POST", "/invites", { clientId, clientDisplayName, contactEmail, notifyEmails }),
  reissue: (inviteId, notifyEmails) => call("POST", `/invites/${e(inviteId)}/reissue`, { notifyEmails }),
  revoke: (inviteId) => call("POST", `/invites/${e(inviteId)}/revoke`, {}),
  clientStatus: (clientId) => call("GET", `/clients/${e(clientId)}`),
  submission: (submissionId) => call("GET", `/submissions/${e(submissionId)}`),
  fileLink: (submissionId, fileId) => call("POST", `/submissions/${e(submissionId)}/files/${e(fileId)}/link`, {}),
  exportSubmission: (submissionId, kind) => call("POST", `/submissions/${e(submissionId)}/exports`, { kind }),
  previewPdf: () => call("GET", "/preview.pdf", undefined, { blob: true }),
  deleteSubmission: (submissionId) => call("DELETE", `/submissions/${e(submissionId)}`),
  restoreSubmission: (submissionId) => call("POST", `/submissions/${e(submissionId)}/restore`, {}),
  dashboard: () => call("GET", "/dashboard"),
  llmText: (clientId) => call("GET", `/llm/clients/${e(clientId)}`),
};
